/* eslint-disable no-underscore-dangle */
import _ from 'lodash';
import React, { Component } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import LazyLoad from 'react-lazyload';
import FilterBar from './FilterBar';
import FileNotFound from '../FileNotFound';
import LoadingPage from '../LoadingPage';
import MaterialSearch from '../MaterialSearch';
import Api from '../../services/ApiService';
import FileService from '../../services/FileService';
import FlexPanel from '../FlexPanel';
import Form from '../form/Form';
import { modal } from '../modal/ModalEmitter';
import AuthService from '../../services/AuthService';
import browserHistory from '../../history';
import PdfObject from '../PdfObject';
import '../../styles/archive.scss';

class ArchiveSearch extends Component {
  constructor(props) {
    super(props);

    this.state = {
      results: [],
      searchText: '',
      count: 0,
      loading: false,
      filter: [
        { name: 'startDate', label: 'Start Date', type: 'date', col: 6 },
        { name: 'endDate', label: 'End Date', type: 'date', col: 6 },
        {
          name: 'signed',
          label: 'Signed',
          control: 'Select',
          options: [
            { label: 'Signed', value: 'Y' },
            { label: 'Unsigned', value: 'N' },
          ],
          col: 3,
        },
        {
          name: 'typeId',
          label: 'Document Type',
          control: 'Tags',
          col: 9,
          collection: true,
          validation: { type: 'db', modelName: 'ArchiveDocType', sortBy: 'name' },
        },
      ],
      filterParams: {},
    };

    this.page = 1;
    this.maxResults = 25;
    this.debouncedGetSearchResults = _.debounce(this.getSearchResults, 250);
    this.docTypes = {};
  }

  componentDidMount() {
    Api.get('archive/docTypes').then(({ data }) => {
      this.docTypes = _.keyBy(data, 'id');
    });
  }

  getSearchResults(query) {
    Api.get('archive/search', {
      params: {
        q: window.btoa(query),
        filter: window.btoa(JSON.stringify(this.state.filterParams)),
        page: this.page,
      },
    }).then(response => {
      if (this.state.searchText === query) {
        // don't update the state if the query has since changed
        const results = this.page > 1 ? [].concat(this.state.results, response.data) : response.data;
        this.setState({
          results,
          loading: false,
          count: results.length || 0,
        });
      }
    });
  }

  handleFilter = () => {
    modal.open('info', {
      title: 'Filter',
      style: 'center',
      size: 'md',
      hidePrint: true,
      hideFooter: true,
      headerClass: 'primary',
      message: (
        <Form
          layout={this.state.filter}
          exportFormat="object"
          onCancel={modal.close}
          submit={this.handleFilterSubmit}
          submitAll
          trackDirty={false}
          useDirtyWarning={false}
        />
      ),
    });
  };

  handleFilterClear = name => {
    const { filter, filterParams } = this.state;

    filterParams[name] = Array.isArray(filterParams[name]) ? [] : '';

    const newFilter = filter.map(obj => {
      if (name === obj.name) {
        if (Array.isArray(obj.data)) {
          obj.data = [];
          obj.dataAlt = [];
        } else {
          obj.data = '';
        }
      }
      return obj;
    });

    this.setState({ filterParams, filter: newFilter, loading: true }, () => {
      return this.getSearchResults(this.state.searchText);
    });
  };

  handleFilterSubmit = data => {
    modal.close();
    const filter = this.state.filter.map(field => {
      if (field.name === 'typeId') {
        field.data = data[field.name] || [];
        field.dataAlt = (field.data || []).map(id => _.get(this.docTypes[id], 'name'));
      } else {
        field.data = data[field.name];
      }
      return field;
    });

    this.setState({ filterParams: data, filter, loading: true }, () => this.getSearchResults(this.state.searchText));
  };

  handleSearch = e => {
    this.page = 1;
    if (!e.target.value) {
      this.setState({ loading: false, searchText: '', results: [], count: 0 });
    } else {
      this.setState({ searchText: e.target.value, loading: true });
      this.debouncedGetSearchResults(e.target.value);
    }
  };

  handleImageClick(obj) {
    if (this.imageClicked) {
      return;
    }

    this.imageClicked = true;

    Api.get('archive', {
      params: {
        id: obj._id,
        signed: obj.signed ? 1 : 0,
      },
    }).then(({ data }) => {
      this.imageClicked = false;
      const pdfUrl = FileService.downloadPath(data.fileName);

      modal.info({
        title: obj.name,
        hidePrint: true,
        // handlePrint: () => this.download(obj._id, obj.signed),
        message: <PdfObject url={pdfUrl} width="100%" height="800" />,
      });
    });
  }

  download(id, signed = false) {
    const newWin = window.open('', '_blank');
    newWin.document.write('Loading...');

    Api.get('archive', {
      params: {
        id,
        signed: signed ? 1 : 0,
      },
    }).then(({ data }) => {
      newWin.document.title = data.fileName;
      newWin.location.href = FileService.downloadPath(data.fileName);
    });
  }

  emailDocument = (docInfo, signed = false) => {
    const { filePath, name } = docInfo;
    const signedDoc = signed ? 'Signed ' : '';
    const title = `Email ${signedDoc} Document`;
    const subject = `${signedDoc}Document ${docInfo.name} Attached`;

    const options = {
      lookupKey: name,
      title,
      emailData: {
        to: [],
        subject,
        html: subject,
        filePath,
        signed,
      },
      render: 'emailDocument',
      hideFooter: true,
      hidePrint: true,
    };

    modal.open('Email Document', options);
  };

  showMore = () => {
    this.page += 1;
    this.getSearchResults(this.state.searchText, this.page);
  };

  linkifyPath(path) {
    if (!AuthService.hasPermission('UPA4')) {
      return path;
    }

    const lastSlashIndex = path.lastIndexOf('/');
    const basename = path.substr(lastSlashIndex + 1);
    const dirname = path.substr(0, lastSlashIndex);

    return (
      <>
        <a
          style={{ cursor: 'pointer' }}
          onClick={() => {
            browserHistory.push(`/UPA4#${dirname}/`);
          }}
        >
          {dirname}/
        </a>
        <b>{basename}</b>
      </>
    );
  }

  renderSearchReference() {
    return (
      <div className="search-reference">
        <Col md={6}>
          <FlexPanel header="General">
            <div>
              <div>Documents containing keyword repair</div>
              <code>repair</code>
            </div>
            <div>
              <div>Documents containing repair AND transmission</div>
              <code>repair transmission</code>
            </div>
            <div>
              <div>Documents containing repair OR transmission</div>
              <code>repair OR transmission</code>
            </div>
          </FlexPanel>
        </Col>

        <Col md={6}>
          <FlexPanel header="Fields">
            <div>
              <div>Document with filename PT317</div>
              <code>name:(PT317)</code>
            </div>
            <div>
              <div>Documents with filename PT317 OR PT323</div>
              <code>name:(PT317 OR PT323)</code>
            </div>
            <div>
              <div>Documents with filename that starts with PT</div>
              <code>name:(PT*)</code>
            </div>
            <div>
              <div>Documents that are signed</div>
              <code>signed:(true)</code>
            </div>
          </FlexPanel>
        </Col>

        <Col md={6}>
          <FlexPanel header="Grouping">
            <div>
              <div>Multiple terms can be grouped to form sub-queries</div>
              <code>(truck OR rig) AND repair</code>
            </div>
            <div>
              <div>You can also target fields</div>
              <code>body:(transmission OR brakes) type:(Repair Orders)</code>
            </div>
          </FlexPanel>
        </Col>

        <Col md={6}>
          <FlexPanel header="Ranges">
            <div>
              <div>Documents dated in 2016</div>
              <code>date:[2016 TO 2017]</code>
            </div>
            <div>
              <div>Documents dated in May 2017</div>
              <code>date:[2017-05-01 TO 2017-05-31]</code>
            </div>
            <div>
              <div>Documents dated before 2012</div>
              <code>
                date:{'{'}* TO 2012{'}'}
              </code>
            </div>
            <div>
              <div>Documents dated after 2012</div>
              <code>
                date:{'{'}2012 TO *{'}'}
              </code>
            </div>
          </FlexPanel>
        </Col>
      </div>
    );
  }

  renderResults() {
    if (this.state.loading) {
      return <LoadingPage />;
    }

    if (!this.state.count && !this.state.searchText && !Object.keys(this.state.filterParams).length) {
      return this.renderSearchReference();
    }

    if (!this.state.count) {
      return <FileNotFound>No results found</FileNotFound>;
    }

    return this.state.results.map((obj, idx) => {
      return (
        <Row key={`ar-${idx}`} className="entry">
          <Col sm={12} md={12} lg={12}>
            <div className="pdf-image-wrapper">
              <a onClick={() => this.handleImageClick(obj)}>
                <LazyLoad>
                  <>
                    {(obj.imageToken || obj.signedImageToken) && (
                      <img
                        alt="pdf"
                        className="pdf-image"
                        src={FileService.downloadPath(obj.signedImageToken || obj.imageToken, 'pdf-img')}
                      />
                    )}
                  </>
                </LazyLoad>
              </a>
            </div>
            <div className="pdf-details">
              <div>
                <div style={{ float: 'right' }}>
                  <span className="badge badge-primary">{obj.type}</span>&nbsp;
                  {obj.signed && <span className="badge badge-danger">Signed</span>}
                </div>
                <div className="file-name">{obj.name}</div>
                <div className="file-path">{this.linkifyPath(obj.filePath)}</div>
              </div>
              <div className="ocr-preview">
                <div className="title">Content Preview</div>
                <pre>{obj.body}</pre>
              </div>
              <div className="toolbar">
                {obj.originalExists && (
                  <>
                    <Button
                      variant="primary"
                      size="sm"
                      onClick={() => {
                        this.download(obj._id);
                      }}
                    >
                      Download
                    </Button>
                    <Button
                      title="Email Document"
                      variant="primary"
                      size="sm"
                      onClick={() => {
                        this.emailDocument(obj);
                      }}
                    >
                      <i className="zmdi zmdi-email zmdi-hc-lg zmdi-hc-fw" />
                    </Button>
                  </>
                )}
                {obj.signed && (
                  <>
                    <Button
                      variant="danger"
                      size="sm"
                      onClick={() => {
                        this.download(obj._id, true);
                      }}
                    >
                      Download Signed
                    </Button>
                    <Button
                      title="Email Signed Document"
                      variant="danger"
                      size="sm"
                      onClick={() => {
                        this.emailDocument(obj, true);
                      }}
                    >
                      <i className="zmdi zmdi-email zmdi-hc-lg zmdi-hc-fw" />
                    </Button>
                  </>
                )}
              </div>
            </div>
          </Col>
        </Row>
      );
    });
  }

  renderPagination() {
    if (this.state.loading || !this.state.count || this.state.count !== this.maxResults * this.page) {
      return null;
    }

    return (
      <div style={{ textAlign: 'center' }}>
        <Button onClick={this.showMore} size="lg" variant="secondary">
          More
        </Button>
      </div>
    );
  }

  render() {
    return (
      <div id="archive-search" className="container-fluid">
        <div id="list-toolbar-wrapper">
          <div id="list-toolbar">
            <Button className="float-right ml-2" onClick={this.handleFilter} variant="secondary">
              <i className="zmdi zmdi-filter-list" /> Filter
            </Button>
            <MaterialSearch
              onChange={this.handleSearch}
              maxResults={this.maxResults}
              placeholder="Enter a keyword"
              results={this.state.count}
              value={this.state.searchText}
            />
          </div>
        </div>
        <div className="clearfix" />
        <FilterBar filters={this.state.filter} handleFilterClear={this.handleFilterClear} />
        <div className="results">{this.renderResults()}</div>
        {this.renderPagination()}
      </div>
    );
  }
}

export default ArchiveSearch;
